import { Box, Paper } from '@mui/material'
import * as React from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

import FeatureDevMapContent from '../assets/FeatureDevMap.md'

export default function FeatureDevMapPage() {
  const [content, setContent] = React.useState('')

  React.useEffect(() => {
    fetch(FeatureDevMapContent)
      .then((res) => res.text())
      .then((text) => setContent(text))
  }, [])

  return (
    <Box sx={{ p: { xs: 2, sm: 3, md: 4 }, ml: 0 }}>
      <Paper
        elevation={2}
        sx={{
          p: { xs: 2, sm: 3 },
          bgcolor: 'background.paper',
          maxWidth: '100%',
          '& ul': {
            listStyle: 'none',
            pl: 2,
            m: 0,
          },
          '& li': {
            m: 0,
            p: 0,
            lineHeight: 1.5,
            textAlign: 'left',
          },
          '& li > ul': {
            pl: 3,
            m: 0,
          },
          '& li::before': {
            content: '"- "',
            color: 'text.secondary',
          },
          '& h1': {
            fontSize: '1.8rem',
            mb: 2,
            textAlign: 'left',
          },
          '& h2': {
            fontSize: '1.4rem',
            mt: 3,
            mb: 1,
            textAlign: 'left',
          },
          '& h3': {
            fontSize: '1.2rem',
            mt: 2,
            mb: 1,
            color: 'text.secondary',
            textAlign: 'left',
          },
          '& p': {
            m: 0,
            p: 0,
            textAlign: 'left',
          },
        }}
      >
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
      </Paper>
    </Box>
  )
}
